<template>
  <div class="animated fadeIn">
    <b-form @submit="addOrUpdateGroupRecord">
      <b-row>
        <b-col md="9" sm="12" class="mb-4">
          <h4 v-if="_.get(this.group, 'id', false)" class="card-title mb-0">{{ this.group.groupName }}</h4>
          <h4 v-if="!this.group.id" class="card-title mb-0">Update Group</h4>
          <div class="small text-muted">Added {{ getGroupAddedDate() }}</div>

        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <!-- Group Form -->
          <GroupForm v-if="group.id" :group="group"></GroupForm>
          <b-row align-h="end">
            <b-col cols="auto" class="p-3">
              <b-button variant="secondary" v-bind:href="'/admin/groups/'+ group.id" class='marginR-32'>Cancel</b-button>
              <b-button variant="primary" @click="addOrUpdateGroupRecord">Submit</b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
     <b-alert
      dismissible
      fade
      :show="groupEditFailure"
      :variant="'danger'">
      <span v-html="groupEditFailure">
      </span>
      </b-alert>


    <h2 v-show="editGroupPending" class="u-padding-bottom-20">Updating, please wait ...</h2>
    <pulse-loader :loading="editGroupPending" :color="spinnerColor" :size="spinnerSize"></pulse-loader>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GroupForm from '@/views/t1/Admin/GroupForm'

export default {
  name: 'editGroup',
  components: {
    GroupForm
  },
  computed: {
    ...mapGetters({
      group: 'getEditGroup',
      recentlyEditedGroup: 'getRecentlyUpdatedGroup',
      editGroupPending: 'getEditGroupPending',
      groupEditFailure: 'getGroupEditFailure'
    }),
    groupId () {
      return this.$route.params.id
    }
  },
  data: function () {
    return {
      spinnerColor: '#0F347B',
      spinnerSize: '50px'
    }
  },
  watch: {
    recentlyEditedGroup: function (newValue) {
      if (newValue) {
        // Send them back to the view user screen
        this.$router.push({ path: '/admin/groups/' + newValue.id })
      }
    }
  },
  methods: {
    getGroupAddedDate: function () {
      const group = this.group
      if (group.createdAt) {
        return this.$utils.unixToHuman(group.createdAt / 1000)
      }
      return 'unknown'
    },
    addOrUpdateGroupRecord () {
      this.$validator.validate().then(result => {
        if (result) {
          let group = _.pick(this.group, [
            'id',
            'groupName',
            'isOwningGroup',
            'defaultOrg'
          ])
          group.groupName = _.trim(group.groupName)
          this.$store.dispatch('updatedGroup', { id: this.groupId, data: group })
        }
      })
    }
  },
  async created () {
    await this.$store.dispatch('getGroupEdit', { id: this.groupId })
  },
  beforeDestroy () {
    this.$store.commit('reseetEditGroup')
  }
}
</script>


// WEBPACK FOOTER //
// src/views/t1/Admin/EditGroup.vue